<template lang="es">
  <v-container fluid class="fill-height">
    <!-- Este es el contenedor principal -->
    <v-row no-gutters class="fill-height">
      <v-col cols="12" class="d-flex fill-height">
        <v-btn
          v-if="is_data"
          @click="descargar"
          class="custom-btn"
          color="primary"
          :style="input.customized.css"
        >
          Descargar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  data() {
    return {
      datos: [],
    };
  },

  props: {
    input: Object,
  },

  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage", "scadaDimensions"]),
    is_data() {
      return this.filtroAVigilar.length > 0;
    },
    filtroAVigilar() {
      try {
        console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
        const a = this.pages[this.selectedPage].item_list.find((item) => {
          return item.name === this.input.filtroAsociado.name;
        });

        console.log("El elegido es", a);
        return a.customized.data;
      } catch (error) {
        return [];
      }
    },

    filtroAsociado() {
      try {
        // console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
        const a = this.pages[this.selectedPage].item_list.find((item) => {
          return item.name === this.input.filtroAsociado.name;
        });

        console.log("El elegido es", a);
        return a.customized;
      } catch (error) {
        return {};
      }
    },
  },

  methods: {
    convertirEstadoEnStrEstado(estado) {
      switch (estado) {
        case 1:
          return "Automático";
        case 2:
          return "Parado";
        case 3:
          return "Alarma";
        case 4:
          return "Mantenimiento";
        default:
          return "??";
      }
    },
    descargar() {
      console.log("Descargar:", this.filtroAVigilar);

      // mapear para convertir las fechas con moment y especificar los textos de los estados
      this.filtroAVigilar.map((d) => {
        d.read_at = moment(d.read_at).format("YYYY-MM-DD HH:mm:ss");
        d.estado = this.convertirEstadoEnStrEstado(d.value);
        return d;
      });

      const keepKeys = ["id", "read_at", "estado"];
      const filteredData = this.filtroAVigilar.map((item) =>
        Object.fromEntries(Object.entries(item).filter(([key]) => keepKeys.includes(key)))
      );

      // Convertir el array a CSV
      const csv = this.convertToCsv(filteredData);

      // Crear un Blob con el contenido CSV
      const blob = new Blob([csv], { type: "text/csv" });

      // Crear un enlace para descargar el Blob
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "datos.csv"; // Nombre del archivo
      a.click();

      // Liberar el objeto URL después de descargar
      URL.revokeObjectURL(url);
    },

    convertToCsv(jsonData) {
      if (jsonData.length === 0) return "";

      // Obtener los encabezados del CSV
      const headers = Object.keys(jsonData[0]);

      // Convertir los encabezados a una fila CSV
      const csvRows = [headers.join(",")];

      // Convertir cada fila de datos JSON a una fila CSV
      for (const row of jsonData) {
        const values = headers.map((header) => {
          const value = row[header];
          return value === null || value === undefined ? "" : `"${String(value).replace(/"/g, '""')}"`;
        });
        csvRows.push(values.join(","));
      }

      // Unir todas las filas con saltos de línea
      return csvRows.join("\n");
    },
  },
};
</script>

<style scoped>
.custom-btn {
  flex: 1;
  width: 100%;
  height: 100% !important;
  background-size: 100% 100%;
  background-position: center;
}

.v-btn {
  display: inline-block;
}
.v-btn >>> .v-btn__content {
  white-space: pre-wrap;
}
</style>
